// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.viewPopup {
    display: flex;
}

.addViewPopover {
    right: -40px !important;
}

.existingViews {
    height: auto;
}

.MuiPaper-root {
    display: flex;
}

.global-icon {
    padding-left: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/molecules/AddViewPopup/index.css"],"names":[],"mappings":";AACA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["\n.viewPopup {\n    display: flex;\n}\n\n.addViewPopover {\n    right: -40px !important;\n}\n\n.existingViews {\n    height: auto;\n}\n\n.MuiPaper-root {\n    display: flex;\n}\n\n.global-icon {\n    padding-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
